import type { KpiFormulaNode, ViewConfigKpi, ViewConfigKpiWithMetric } from '../../schemas/view_config/kpi.ts'
import { getMetricFromKpiFormula } from './getMetricFromKpiFormula.ts'

/**
 * 読み取り面 `ViewConfigKpiWithMetric` を永続化用の前段層 `ViewConfigKpi` に戻す純粋関数。
 * `viewConfigKpiToMetric` (inline → Metric) の逆写像で、`formula.metric` に合成されている
 * sheet/measure/date/user を inline に書き戻す。
 *
 * 永続化 (updateView) は inline を入力形として受け取り、読み取り時に attachMetricToView が
 * inline から formula.metric を再導出する。read-modify-write の編集で formula.metric だけを
 * 更新して inline を古いまま保存すると、次回読み取りで古い inline から metric が再導出され、
 * 編集内容 (絞り込み等) が失われる。保存境界でこの関数を通し、inline を最新の metric に一致させる。
 */
export const viewConfigKpiWithMetricToInline = (config: ViewConfigKpiWithMetric): ViewConfigKpi => {
  const metric = getMetricFromKpiFormula(config.formula)
  const formula: KpiFormulaNode =
    config.formula.type === 'ref' ? { type: 'ref', metricId: config.formula.metricId } : { type: 'empty' }
  return {
    ...config,
    formula,
    sheet: metric?.sheet,
    measure: metric?.measure,
    date: metric?.date,
    user: metric?.user,
  }
}
